class MainCollectionSection extends HTMLElement {
  constructor() {
    super();
    this.collectionReadOnlyKey = "dded12a5497d69acfcfd27f2026ca410";
    this.collectionHandle = this.getAttribute("handle");

    this.productsSliders = this.querySelectorAll(".productsSlider");

    document.addEventListener("DOMContentLoaded", this.connectedCallback.bind(this));
  }

  connectedCallback() {
    const bestSliderEl = this.querySelector(".bestSeller");
    const latestSliderEl = this.querySelector(".latest");
  
    this.fetchCollectionProducts(10, "BEST_SELLING").then((products) => {
      const wrapper = bestSliderEl.querySelector(".swiper-wrapper");
      products.forEach((product) => {
        const productCard = document.createElement("div");
        productCard.className = "card swiper-slide";
        productCard.innerHTML = this.getProductCardHtmlString(product);
        wrapper.appendChild(productCard);
      });
  
      new Swiper(bestSliderEl, {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: true,
        navigation: {
          nextEl: bestSliderEl.querySelector(".swiper-button-next"),
          prevEl: bestSliderEl.querySelector(".swiper-button-prev"),
        },
        scrollbar: {
          el: bestSliderEl.querySelector(".swiper-scrollbar-best"),
          draggable: true,
          hide: false,
        },
        breakpoints: {
          640: { slidesPerView: 2 },
          768: { slidesPerView: 3 },
          1024: { slidesPerView: 4 },
          1425: { slidesPerView: 5 },
        },
      });
    });
  
    this.fetchCollectionProducts(10, "MANUAL", true).then((products) => {
      const wrapper = latestSliderEl.querySelector(".swiper-wrapper");
      products.forEach((product) => {
        const productCard = document.createElement("div");        
        productCard.className = "card swiper-slide";
        productCard.innerHTML = this.getProductCardHtmlString(product);
        wrapper.appendChild(productCard);
      });
  
      new Swiper(latestSliderEl, {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: true,
        navigation: {
          nextEl: latestSliderEl.querySelector(".swiper-button-next"),
          prevEl: latestSliderEl.querySelector(".swiper-button-prev"),
        },
        scrollbar: {
          el: latestSliderEl.querySelector(".swiper-scrollbar-latest"),
          draggable: true,
          hide: false,
        },
        breakpoints: {
          640: { slidesPerView: 2 },
          768: { slidesPerView: 3 },
          1024: { slidesPerView: 4 },
          1425: { slidesPerView: 5 },
        },
      });
    });
  }
  

  getProductCardHtmlString(product) {
    
    
    return `
        <div class="card__media has-hover-image relative">
            <img class="card-image-0" width="200" height="auto" src="${product.images[0]}" alt="${product.title}"/>
            <img class="card-image-1" width="200" height="auto" src="${product.images[product.images[1] ? 1 : 0]}" alt="${product.title}"/>
        </div>
        <div class="card__info-inner flex flex-col-space-between w-full row-gap-10" style="padding: 20px 0;">
            <p class="card__title card-title font-bold mb-1" style="max-height:250px; margin-bottom: 20px; color: #14465f;">
                <a href="/collections/${this.collectionHandle}/products/${product.handle}" class="card-link text-current card-title">${product.title}</a>
            </p>
            <div style="text-align: center;">
                <div class="rating inline-block align-middle" role="img" aria-label="5.0 out of 5.0 stars">
                    <span class="rating__stars" aria-hidden="true" style="--rating: 5; --rating-max: 5.0;">★★★★★</span>
                </div>
                <div class="rating__count inline-block align-middle text-sm">(${product.ratingCount})</div>
            </div>
            <div
                class="flex grow items-end"
                style="
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                "
            >
                <div class="price price--bottom">
                    <div class="price__default" style="color: #14465f">
                    <span class="price__from" style="font-weight: bold; font-size: 16px"
                        >
                        <span class="transcy-money">$${parseFloat(product.priceRange.maxVariantPrice.amount).toFixed(2)}</span>
                    </span> 
                    <span style="color:#5AAAB3">as low as <span class="transcy-money">$${(parseFloat(product.priceRange.maxVariantPrice.amount) - (parseFloat(product.priceRange.maxVariantPrice.amount) * 0.1)).toFixed(2)}</span></span>                   
                </div>
            </div>
        </div>
    `;
  }

  fetchCollectionProducts(limit, filter, reverse = false) {
    const reverseStr = reverse ? ", reverse: true" : "";
    const query = `
      {
        collection(handle: "${this.collectionHandle}") {
          title
          description
          products(first: ${limit}, sortKey: ${filter}${reverseStr}) {
            edges {
              node {
                id
                title
                handle
                description
                createdAt
                productType
                vendor
                tags
                metafield(namespace: "reviews", key: "rating_count") {
                  value
                }
                images(first: 2) {
                  edges {
                    node {
                      url
                    }
                  }
                }
                priceRange {
                  minVariantPrice {
                    amount
                    currencyCode
                  }
                  maxVariantPrice {
                    amount
                    currencyCode
                  }
                }
              }
            }
          }
        }
      }
    `;
  
    return fetch("https://wholedent.com/api/2025-04/graphql.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": this.collectionReadOnlyKey,
      },
      body: JSON.stringify({ query }),
    })
      .then((res) => res.json())
      .then((data) => {
        const products = data.data.collection.products.edges.map((prodEdge) => {
          return {
            ...prodEdge.node,
            ratingCount: prodEdge.node.metafield?.value || null,
            images: prodEdge.node.images.edges.map((edge) => edge.node.url),
          };
        });
        return products;
      })
      .catch((err) => console.error(err));
  }
  
}

customElements.define("main-collection-section", MainCollectionSection);
